'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _multiSelectListLocal = require('./multi-select-list.local.css');

var _multiSelectListLocal2 = _interopRequireDefault(_multiSelectListLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function MultiSelectList(props) {
  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('ul', {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      props.onPress(e);
    },
    className: _multiSelectListLocal2.default.multiSelectList
  }, _react2.default.Children.map(props.children, function (child) {
    return _react2.default.cloneElement(child, {
      className: (0, _classnames2.default)(_multiSelectListLocal2.default.li, child.props.selected ? _multiSelectListLocal2.default.selected : null, child.props.highlight === true || child.props.highlight === 'true' ? _multiSelectListLocal2.default.highlight : null, child.props.highlight === true || child.props.highlight === 'true' ? 'MSLChild' : null),
      selected: Boolean(child.props.selected)
    });
  })));
}

MultiSelectList.propTypes = {
  /**
   * A function that is passed to the list's <ul> element as an onClick handler.
   */
  onPress: _propTypes2.default.func,

  /**
   * All children must be li component instances.
   */
  children: function children(props, propName, componentName) {
    var prop = props[propName];

    _react2.default.Children.forEach(prop, function (child) {
      if (child.type !== 'li') {
        throw new Error(componentName + ' only accepts children of type \'li\'. Child type is ' + child.type);
      }
    });
  }
};
MultiSelectList.defaultProps = {
  onPress: function onPress() {}
};
exports.default = MultiSelectList;